import { UserPreferencesServiceMock } from "./userPreferences.types";

export const mockUserPreferencesService = (): UserPreferencesServiceMock => ({
  fetchUserPreferencesV2: jest.fn(),
  saveUserPreferencesV2: jest.fn(),
});
